module.exports = __webpack_public_path__ + "static/media/7.dd34a470.jpg";